import React from 'react';
import http from '../modules/api';

import * as StringUtil from '../modules/utils/StringUtil';

import ReactGA from 'react-ga';
// ReactGA.initialize('UA-78553461-8');

// var ga_label = sessionStorage.getItem("userName") + "(" + sessionStorage.getItem("user_id") + ")";

var calc_payment = false;
var fromExpect = false;
var pf = null;
var isPayLinkClick = false;

export class OrderProcessing extends React.Component {

    constructor(props) {
        super(props);
        
        this.state = {
            // order_no: StringUtil.getUrlParams("ORDER_NO"),
        }
    }

    componentDidMount(e) {
    }

    componentDidUpdate() {
    }

    componentWillUnmount () {
    }

    /**
     * 결제 완료 처리
     * 결제 완료 처리 후 주문 번호에 해당하는 서비스를 이용중 상태로 변경한다.
     */ 
    updateOrderComplete () {

    }
 
    
    // 결제를 위한 금액 데이터 세팅
    // fn_saveRequestMembership() {
    //     let sendForm = {
    //         req_payment_type_list:  this.state.req_payment_type_list,
    //         req_coupon_list:  this.state.req_coupon_list,
    //         order_type : this.state.order_type,          /*결제타입 (정기결제 / 실시간결제)  [02001	정기결제, 02002	실시간계좌이체]*/
    //         //std_date: '2021-02-28',
    //         //std_ym: '2021-02',
    //         // service_type: this.state.service_type,
    //         // request_type: this.state.request_type,
    //         // payment_type: this.state.payment_type,
    //         // req_banner_list: this.state.req_bannerList,
    //         // coupon_no: this.state.coupon_no,
    //     };
    //     const config = {
    //         headers: {
    //             'content-type': 'application/json;'
    //         }
    //     }
    //     // 결제금액, 잔여금액, 추가금액을 계산하여 저장
	// 	http.post("/rest/shop/saveRequestMembership", sendForm, config)
    //         .then(
	// 		    resultData => {
    //                 const { data } = resultData;
    //                 console.log(data);
    //                 if (data.code == 200) {
    //                     //let payment_amount_seq = data.PAYMENT_AMOUNT_SEQ;
    //                     let order_type = this.state.order_type;
    //                     // 최종 요청 금액으로 결제모듈 호출
    //                     if (order_type == '02001') {
    //                         // 카드결제 
    //                         // this.fn_cardBatch(payment_amount_seq);
    //                         alert("결제가 완료 되었습니다.");
    //                         // 결제내역 페이지로 이동
    //                         this.props.history.push(
    //                             {
    //                                 pathname: `/shop/order/list`,
    //                                 state: {prevPath: window.location.href}
    //                             }	
    //                         )
    //                     } else if (order_type == '02002') {
    //                         // 실시간 계좌이체
    //                         if (data.result) {
    //                             // PG창 호출 이벤트
    //                             isPayLinkClick = true;
    //                             this.setState({payLinkPreData: data});
    //                         } else {
    //                             alert("결제에 실패하였습니다.\n관리자에게 문의해주세요(1599-3518)");
    //                         }
    //                         //this.fn_payLink(payment_amount_seq);
    //                     } else if (order_type == '02003') {
    //                         // 일반 카드결제
    //                         if (data.result) {
    //                             // PG창 호출 이벤트
    //                             isPayLinkClick = true;
    //                             this.setState({payLinkPreData: data});
    //                         } else {
    //                             alert("결제에 실패하였습니다.\n관리자에게 문의해주세요(1599-3518)");
    //                         }
    //                         //this.fn_payLink(payment_amount_seq);
    //                     }
    //                 } else {
    //                     alert(data.msg);
    //                 }
    //             }
    //         ).catch(
	// 		    error => { alert("서비스 점검중 입니다."); console.log(error); }
	// 		);
    // }


	render() {
        return (
            <div id='page-wrapper' className="container" style={{backgroundColor: '#ffffff', minHeight:"100%"}}>
                <div>
                    <b>카드사 심사용 결제가 정상적으로 완료되었습니다.</b><br/>
                    <span style={{fontSize: "13px", color: "#333"}}>
                        ※ 원활한 카드사 심사를 위해, 결제하신 요금제는 실제 이용 상태로 전환되지 않습니다. (재결제가 가능하도록 하기 위함입니다.)
                    </span>
                </div>
                <button id="button_step_next" class="btn-auto-b" style={{height: "auto", padding: "16px 23px 16px", marginTop: "30px", marginBottom: "40px"}}
                onClick={() => {window.location.href = "/shop/orderNew_v3"}}>
                    다시 결제 하러 가기
                </button>
            </div>
        )
    }
}   